"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { captureCroTrackingFromPath } from "@/utils/croTracking";
import { ensureFirstLandingPage } from "@/utils/firstLandingPage";

export default function FirstLandingPageInitializer() {
  const pathname = usePathname();

  useEffect(() => {
    const currentPath =
      (typeof window !== "undefined" && window.location.pathname) ||
      pathname ||
      "/";
    ensureFirstLandingPage(currentPath);
    captureCroTrackingFromPath(currentPath);
  }, [pathname]);

  return null;
}
